import { PaginatedDataSheetLogisticsEstimates } from '@lune-fe/dapi-models'
import { TableNew } from '@lune-fe/lune-ui-lib'
import { FC, RefObject } from 'react'

import { formatNumberWithFallback } from 'utils'
import {
    DataSheetEstimateContextMenu,
    EmissionCalculationRow,
    EstimateTypeName,
    EstimateTypeSlug,
} from 'views/CalculateEmissions'
import { formatLocation } from 'views/CalculateEmissions/Shared/utils'

// Extract the individual logistics estimate type from the paginated response
type DataSheetLogisticsEstimate = PaginatedDataSheetLogisticsEstimates['data'][0]

const DataSheetLogisticsRow: FC<{
    calculation: DataSheetLogisticsEstimate
    currentPage: number
    pageHistoryRef: RefObject<(string | undefined)[]>
    queryParams: string | undefined
}> = ({ calculation, currentPage, queryParams, pageHistoryRef }) => {
    const estimateType = calculation.estimateType
    const slug = EstimateTypeSlug(estimateType)

    return (
        <EmissionCalculationRow
            id={calculation.id}
            slug={slug}
            emissionType={EstimateTypeName(estimateType)}
            estimateType={estimateType}
            contextMenu={<DataSheetEstimateContextMenu quantity={calculation.mass.amount} />}
            currentPage={currentPage}
            pageHistoryRef={pageHistoryRef}
            queryParams={queryParams}
        >
            <TableNew.TableCell colSize={4} oneLineText>
                {formatLocation(calculation.source)}
            </TableNew.TableCell>
            <TableNew.TableCell colSize={4} oneLineText>
                {formatLocation(calculation.destination)}
            </TableNew.TableCell>
            <TableNew.TableCell alignEnd colSize={1} oneLineText>
                {calculation.numLegs}
            </TableNew.TableCell>
            <TableNew.TableCell alignEnd colSize={2} oneLineText>
                {formatNumberWithFallback(calculation.mass.amount, {
                    decimals: 2,
                    decimalsWhenLessThan: 6,
                    fallback: '--',
                })}
            </TableNew.TableCell>
        </EmissionCalculationRow>
    )
}

export default DataSheetLogisticsRow
